import React, { useEffect, useState } from "react";
import { Form, message, Checkbox, Modal, Skeleton, Row, Col } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectResourceList, UploadFile, UploadButton, InputDate } from "@comps/components"
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { getAllEmployeesReq, updateEducationReq } from "../requests";
import { Commons, Const } from "../../constants";
import dayjs from 'dayjs';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { employeeTooltips } from "../../common/employeeTooltips";
const langKey = Const["education"].lngKey
const fieldLabel = makeFieldLabel(employeeTooltips.education, { namespace: "education", label: (key) => trans(`${langKey}.${key}`) });

const formName = "updateEducation";

const UpdateEducation = (props) => {

  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [isDegreeCompleted, setIsDegreeCompleted] = useState(false);
  const [saving, setsaving] = useState(false);
  const [loading, setloading] = useState(true);
  const [form] = Form.useForm()
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    getAndSetRecord()
    makeRequestStateless(getAllEmployeesReq, false, ongetAllEmployees, false)
    // eslint-disable-next-line
  }, []);

  const getAndSetRecord = () => {
    if (!props.record) {
      return;
    }
    setFileList(props.record.degree_attachment ? [props.record.degree_attachment] : [])
    setIsDegreeCompleted(props.record.is_degree_completed)
    props.record.from_date = props.record.from_date ? dayjs(props.record.from_date) : null
    props.record.to_date = props.record.to_date ? dayjs(props.record.to_date) : null
    form.setFieldsValue(props.record)
  }
  const ongetAllEmployees = (response) => {
    setloading(false)
  }

  const onSubmit = (data) => {

    data.degree_attachment = fileList.length > 0 && fileList[0].id === undefined ? fileList[0].originFileObj : null
    if (data.to_date === undefined) {
      data.to_date = null
    }
    const payload = { employee_education: { ...data }, filters: props.filters }
    payload.id = props.record.id;
    makeRequest(setLoader, updateEducationReq, payload, onSuccess, onError);
    setsaving(true)
  }

  const onSuccess = (data, res) => {
    message.success("Education Saved successfully");
    props.onCompleted(data.employee_educations.data);
  }

  const onError = (err, res) => {
    setsaving(false)
    message.error(res.response.data.message);
    //setErrors(errorList);
  }
  //-----------on changes------------
  const onChangeIsDegree = (e) => {
    setIsDegreeCompleted(e.target.checked)
  }

  // ------------------------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    props.disabled ? '' :
      <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons[props.disabled ? 'view' : 'update']) } subTitle={ trans(`${langKey}.education`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } disabled={ props.disabled } scrollToFirstError>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="employee_id" label={ fieldLabel("employee_id", trans(`${langKey}.select.employee`)) } rules={ rules.employee_id } className="da-mb-16"
                { ...getErrorProps(errors['employee_id']) }
              >
                <SelectResourceList type='employee'
                  disabled={ props.filters !== undefined }
                  value={ props.record.employee_id }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="institute_name" rules={ rules.institute_name } label={ fieldLabel("institute_name", trans(`${langKey}.institute_name`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['institute_name']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.institute_name`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="degree" rules={ rules.degree } label={ fieldLabel("degree", trans(`${langKey}.degree`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['degree']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.degree`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item valuePropName="checked" name="is_degree_completed" label={ fieldLabel("is_degree_completed", trans(`${langKey}.is_degree_completed`)) } className="da-mb-16">
                <Checkbox onChange={ onChangeIsDegree }></Checkbox>
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="from_date" rules={ rules.from_date } label={ fieldLabel("from_date", trans(`${langKey}.from_date`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['from_date']) } size="small"

              >
                <InputDate format='YYYY-MM-DD' />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="to_date" rules={ isDegreeCompleted ? rules.to_date : [] } label={ fieldLabel("to_date", trans(`${langKey}.to_date`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['to_date']) } size="small"

              >
                <InputDate format='YYYY-MM-DD' />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="country" rules={ rules.country } label={ fieldLabel("country", trans(`${langKey}.country`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['country']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.country`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item label={ fieldLabel("degree_attachment", trans(`${langKey}.attachment`)) } name="degree_attachment" >
                <UploadFile fileList={ fileList } setFileList={ setFileList } accept='.pdf,.jpg,.png,.jpeg,.pdf' />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="city" rules={ rules.city } label={ fieldLabel("city", trans(`${langKey}.city`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['city']) } size="small"

              >
                <InputText placeholder={ trans(`${langKey}.city`) } />
              </Form.Item>
            </Col>

          </Row>

        </Form>

      </Skeleton>

    </ModalComponent>
  )
}

export default UpdateEducation

const rules = {
  degree: [
    { required: true, message: trans(`${langKey}.degree.req`) },
  ],
  employee_id: [
    { required: true, message: trans(`${langKey}.employee_id.req`) },
  ],
  institute_name: [
    { required: true, message: trans(`${langKey}.institute_name.req`) },
  ],
  from_date: [
    { required: true, message: trans(`${langKey}.from_date.req`) },
  ],
  to_date: [
    { required: true, message: trans(`${langKey}.to_date.req`) },
  ],
};

const formLayout = {
  layout: "vetical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}